import { supabaseWeather } from 'Services/supabaseClient'

export function fetchUniqueCountriesData() {
  return supabaseWeather.rpc('get_countries_for_weather')
}

export function fetchUniqueStatesData(countryId) {
  return supabaseWeather.rpc('get_states_for_country', { p_country_id: countryId })
}

export function fetchFortNightWeatherData(locationId) {
  return supabaseWeather.rpc('cww_fetch_weather_forecast', { location_id: locationId })
}

export function fetchHourlyWeatherData(locationId, forecastDate) {
  return supabaseWeather.rpc('cww_fetch_weather_hourly', { location_id: locationId, forecast_date: forecastDate })
}

export function fetchUniqueRegionsData(countryId, stateName) {
  return supabaseWeather.rpc('get_regions_for_country_state', { p_country_id: countryId, p_state_name: stateName })
}

export function fetchCountryStateRegionLocations(countryId, stateName, regionName) {
  return supabaseWeather.rpc('get_locations_for_country_state_region', { p_country_id: countryId, p_state_name: stateName, p_region_name: regionName })
}
